import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import SwipeTabs from '../components/SwipeTabs';
import { copyText, formatDate } from '../Helpers';
import { GAME_TYPES } from '../Constants';
import OneUser from '../ones/OneUser';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ friends, setFriends ] = useState([]);
  const [ friendRequests, setFriendRequests ] = useState([]);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  

  const getFriends = () => {
    return new Promise(async resolve => {
      setLoading(true);
      await callGameServerApi('get-user-friends', {}).then(response => {

        setLoading(false);
        if(response.status === 1) {
          setFriends(response.friends);
          resolve();
        } else {
          appContext.tellError('Could not fetch friends');
          appContext.tellError(response.msg)
        }
      })
    })
  }

  const getFriendRequests = () => {
    return new Promise(async resolve => {
      setLoading(true);
      await callGameServerApi('get-user-friend-requests', {}).then(response => {

        setLoading(false);
        if(response.status === 1) {
          setFriendRequests(response.friendRequests);
          resolve();
        } else {
          appContext.tellError('Could not fetch friend requests');
          appContext.tellError(response.msg)
        }
      })
    })
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation); //legacy code
    //appContext.orientationChecker();
    await getFriends().then(async() => {
      await getFriendRequests().then(() => {
        setReady(true);
      })
    })
  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="My Friends"/>
        <div className="FullPane" id="_fullPane1" data-support-top-bar={true}>
          <SwipeTabs
            tabs={[
              {
                id: 'friends',
                title: 'Friends',
                view: (
                  <div className="container-fluid">
                    <h5 style={{ marginBottom: "20px",  marginTop: "30px" }} className="font-light text-muted">All Friends ({friends.length})</h5>
                    {
                      friends.map((item, i) => {
                        return (
                          <OneUser refresher={getFriends} key={i} id={item.id} />
                        )
                      })
                    }
                  </div>
                ),
              },
              {
                id: 'requests',
                title: 'Requests',
                view: (
                  <div className="container-fluid">
                    <h5 style={{ marginBottom: "20px",  marginTop: "30px" }} className="font-light text-muted">Friend Requests ({friendRequests.length})</h5>
                    {
                      friendRequests.map((item, i) => {
                        return (
                          <OneUser refresher={getFriendRequests} key={i} id={item.id} />
                        )
                      })
                    }
                  </div>
                ),
              }
            ]}
          />
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
